// extracted by css-extract-rspack-plugin
export default {"popper":"ArticlePurchasePriceWithHistoryCell_popper__7LQ6x","secondaryInfo":"ArticlePurchasePriceWithHistoryCell_secondaryInfo__RAEFB"};